import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'dg-emp-search-lib';

@Component({
  selector: 'app-select-case-dialog.component.',
  templateUrl: './select-case-dialog.component.html',
  styleUrls: ['./select-case-dialog.component.scss'],
})
export class SelectCaseDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {
  }
}
